<script>import {
  WeekNumberSystem,
  getMonthIndices,
  getMonthLabels,
  getFirstMonth
} from "../../../util/date-time-util.js";
import Picker from "./Picker.svelte";
import { createEventDispatcher } from "svelte";
const _browser = typeof window !== "undefined";
export let name = void 0;
export let value = (/* @__PURE__ */ new Date()).getMonth();
export let locale = void 0;
export let system = WeekNumberSystem.ISO8601;
export let makeSquare = true;
const dispatch = createEventDispatcher();
const getLocale = (locale2) => {
  return locale2 && locale2 !== "undefined" ? locale2 : _browser ? navigator.language : "en-US";
};
let cellContentPadding = "0em";
let cellPadding = "0.3em";
let columns = 3;
$:
  monthLabels = getMonthLabels(getLocale(locale));
const firstMonth = getFirstMonth(system);
const monthIndices = getMonthIndices(firstMonth);
let open = false;
$:
  monthStr = value !== void 0 ? monthLabels ? monthLabels.short[value] : value.toString() : "&nbsp;&nbsp;&nbsp;";
const getMonthCell = (monthIndex, cellIndex, columns2) => {
  return {
    type: "primary",
    marked: false,
    selected: monthIndex === value,
    inside: false,
    value: monthIndex,
    label: monthLabels.short[monthIndex],
    valueTop: cellIndex < columns2,
    valueLeft: cellIndex % columns2 === 0
  };
};
let cells = [];
$: {
  if (monthLabels) {
    cells = monthIndices.map(
      (monthIndex, cellIndex) => getMonthCell(monthIndex, cellIndex, columns)
    );
  }
}
const cellClicked = (ev) => {
  const index = ev.detail.index;
  const cell = ev.detail.cell;
  if (cell && !cell.disabled && (cell.type === "primary" || cell.type === "secondary")) {
    cells = cells.map((c, i) => {
      c.selected = i === index;
      return c;
    });
    value = cells[index].value;
    dispatch("changed", { name, value });
    open = false;
  }
  dispatch("action");
};
const moveTo = (delta) => {
  console.log("month-picker moveTo with cur value = ", value);
  if (value !== void 0) {
    value += delta;
    dispatch("changed", { name, value });
  }
  open = false;
  dispatch("action");
};
const showCells = () => {
  if (cells !== void 0 && cells.length > 0) {
    open = true;
  }
  dispatch("action");
};
</script>

<div
	class="picker month-picker"
	on:blur={() => {
		open = false;
	}}
	tabindex="-1"
>
	<span>
		<span
			class="button icon-chevron-left"
			on:keypress={(ev) => moveTo(-1)}
			on:click={(ev) => moveTo(-1)}
			role="button"
			tabindex="0"
		/><span class="open" role="button" tabindex="0" on:keypress={showCells} on:click={showCells}
			>{monthStr}</span
		><span
			class="button icon-chevron-right"
			on:keypress={(ev) => moveTo(+1)}
			on:click={(ev) => moveTo(+1)}
			role="button"
			tabindex="0"
		/>
	</span>
	<div class={open ? 'open' : ''}>
		<Picker
			{cells}
			cellCharWidth={3}
			itemCharWidth={3}
			{cellContentPadding}
			{cellPadding}
			{columns}
			{makeSquare}
			on:cell-click={cellClicked}
		/>
	</div>
</div>

<style>
	div.picker {
		--base-color-onSurface-primary: #dbe4e7;
		--base-color-primary-default: #6bae85;
		--font-family: Roboto;
		--font-size: 1.125rem;
		--font-weight: 700;
		--letter-spacing: 0.0625rem;
	}

	div.picker {
		--picker-font: normal var(--font-weight) var(--font-size) / 1.2 var(--font-family);
		--picker-font-spacing: var(--letter-spacing);
		--picker-text-color: var(--base-color-onSurface-primary);
		--picker-button-color: var(--base-color-primary-default);
	}

	div.picker.month-picker {
		display: inline-block;
		vertical-align: bottom;
	}

	.picker > span {
		background-color: transparent;
		color: var(--picker-text-color);
		font: var(--picker-font);
		letter-spacing: var(--picker-font-spacing);
		line-height: 1.22222;
	}

	.picker > div {
		position: absolute;
		display: none;
		left: 0;
	}
	.picker > div.open {
		display: block;
		z-index: 10000;
	}

	div.picker.month-picker > span {
		display: inline-flex;
		align-items: center;
		align-content: stretch;
		gap: 0.65em;
	}

	div.picker.month-picker > span > span.open {
		flex: 1 0 auto;
		cursor: pointer;
	}
	div.picker.month-picker > span > span.button {
		flex: 0 0 auto;
		cursor: pointer;
	}
</style>
